import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/shop/availabilities'

export default {
  async searchVehicleRental(request) {
    return await axios
      .post(endpoint + '/rental', request)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async searchVehicleAirport(request) {
    return await axios
      .post(endpoint + '/airport', request)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async selectVehicle(request) {
    return await axios
      .post(`${endpoint}/vehicle`, request)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async loadBookingForm(request) {
    return await axios
      .post(`${endpoint}/form`, request)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/shop/availability/instantAvailabilityService.js